import { ConcessionLayer } from "./ConcessionLayer";
import { DetectedMinesLayer } from "./DetectedMinesLayer";
import { DeforestationLayer } from "./DeforstationLayer";
import { IndigenousLayer } from "./IndigenousLayer";

export const RenderBackgroundLayers: React.FC<{
  activeLayers: ActiveLayers;
}> = ({ activeLayers }) => (
  <>
    <ConcessionLayer active={activeLayers.concessions} />
    <DetectedMinesLayer active={activeLayers.detectedMines} />
    <DeforestationLayer active={activeLayers.deforestations} />
    <IndigenousLayer active={activeLayers.indigenous} />
  </>
);
